<template>
  <div
    class="toggle"
    :class="{ 'toggle--active': toggled }"
    @click.self="switchToggle"
  >
    <button
      type="button"
      class="toggle__button"
      :class="{ 'toggle__button--active': toggled }"
      @click="switchToggle"
    ></button>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ToggleButton",
  props: {
    activeStatus: { type: Boolean },
    disabled: { type: Boolean, default: () => false },
    value: { type: Boolean, default: false },
    reset: { type: Boolean, default: false },
  },
  data() {
    return {
      toggled: false,
    };
  },
  computed: {
    ...mapState({
      organisationDetails: (state) =>
        state.organisationModule.organisationDetails,
      teamMember: (state) => state.organisationModule.teamMember,
    }),
  },
  emits: ["value-selected"],
  mounted() {
    // If value prop is provided, use it (for API client live mode)
    if (this.value !== undefined && this.value !== null) {
      this.toggled = this.value;
    } else if (this.activeStatus && this.teamMember) {
      this.toggled = this.teamMember?.two_factor_enabled;
    } else {
      this.toggled = this.organisationDetails?.two_factor_enabled;
    }
  },
  methods: {
    switchToggle() {
      if (this.disabled) return;
      this.toggled = !this.toggled;
    },
  },
  watch: {
    toggled(val) {
      this.$emit("value-selected", val);
    },
    activeStatus(val) {
      this.toggled = this.organisationDetails?.two_factor_enabled;
    },
    value(newVal) {
      // Update toggled when value prop changes
      if (newVal !== undefined && newVal !== null) {
        this.toggled = newVal;
      }
    },
    reset(newVal) {
      // Reset to value prop when reset changes
      if (newVal) {
        this.toggled = this.value;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.toggle {
  width: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  height: 25px;
  background: #716e89;
  padding-left: 2px;
  padding-right: 2px;
  transition: all 200ms ease-in-out;
  cursor: pointer;
  &--active {
    background: #4d84ff;
  }
  &__button {
    border-radius: 50%;
    border: 0;
    width: 20px;
    height: 20px;
    background: #fff;
    padding: 0;
    margin-bottom: 1px;
    transform: translateY(0.5px);
    transition: transform 300ms ease-in-out;
    &--active {
      transform: translateX(15px);
    }
  }
}
</style>
